import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import styles from "./components.module.scss";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";


const AssistantSkillsCheckModal = ({onClose, onSaveAndContinue}: { onClose: (e: any) => void, onSaveAndContinue: () => void }) => {
  
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>
                    Have you selected all your Skills & Qualifications?
                </div>
                <CrossButtonBlack
                    className={clsx("no-fastclick", styles.crossButtonDark)}
                    onClick={onClose}
                />
            </div>
            <div className={styles.description}>
                Dental offices often look for important qualifications like taking <b>x-rays</b>, active <b>CPR</b>, and <b>sterilization</b> certification. Have you checked off all your verified skills?
            </div>
            <StyledButton
                variant="contained"
                color="primary"
                size="large"
                onClick={onSaveAndContinue}
            >
                Yes, save and continue
            </StyledButton>
            <StyledButton
                variant="outlined"
                color="primary"
                size="large"
                onClick={onClose}
            >
                Go back and review
            </StyledButton>
        </>
    );
}

export default AssistantSkillsCheckModal;